import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./home.css";

export default function JoinAsLawyer() {
  const { t } = useTranslation();
  return (
    <section className="avc-cta">
      <div className="container avc-cta__inner">
        <span className="avc-cta__icon">
          <i className="fas fa-balance-scale" aria-hidden="true"></i>
        </span>
        <div className="avc-cta__body">
          <h2 className="avc-cta__title">{t("home_cta_title")}</h2>
          <p className="avc-cta__text">{t("home_cta_text")}</p>
        </div>
        <Link to="/Register" className="avc-cta__btn">
          {t("home_cta_button")}
        </Link>
      </div>
    </section>
  );
}
